import React, {useEffect, useState} from "react";
import styles from "./Form.module.css";
import PanelForm from "../panel/Form";
import {useNavigate, useSearchParams} from "react-router-dom";
import {AppApi} from "../AppApi"
import {Checkbox} from "primereact/checkbox";
import Button from "./../common/botton/Button";
import {InputText} from "primereact/inputtext";
import ListItem from "../trip/ListItem";
import {createSearchParams} from "react-router";



export default function Form() {

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [bookingLoginInvalid, setBookingLoginInvalid] = useState(false)
    const [bookingLogin, setBookingLogin] = useState({
        email: null,
        code: null
    });
    const [booking, setBooking] = useState(null);
    const [expandedRecognizedState, setExpandedRecognizedState] = useState(null);
    const [confirmRequest, setConfirmRequest] = useState({
        bookingId: "",
        firstName: "",
        lastName: "",
        street: "",
        houseNumber: "",
        city: "",
        state: "",
        country: "",
        mobilePhone: ""
        });
    const [checkAgbAccepted, setCheckAgbAccepted] = useState(false);
    const [checkBildungsurlaubAccepted, setCheckBildungsurlaubAccepted] = useState(false);
    const [highlightCheckboxes, setHighlightCheckboxes] = useState(false);

    useEffect(() => {
        if(searchParams != null && searchParams.get("email") != null && searchParams.get("code") != null) {
            AppApi.pub.getBooking(-1, {email: searchParams.get("email"), code: searchParams.get("code")})
                .then(response => {
                    setBooking(response.data)
                    if(response.data?.extension?.account){
                        setConfirmRequest(response.data?.extension?.account)
                    }
                })
                .catch( (error) => {
                    setBooking(null)
                    setBookingLogin({
                        email: null,
                        code: null
                    })
                    setBookingLoginInvalid(true)
                })
        }
    }, [searchParams]);



    function postBookingConfirm() {
        confirmRequest.bookingId = booking.id
        AppApi.pub.postBookingConfirm(confirmRequest)
            .then(response => {
                setBooking(response.data)
            })
            .catch( (error) => {
                setBooking(null)
                setBookingLogin({
                    email: null,
                    code: null
                })
                setBookingLoginInvalid(true)
            })
    }



    function openBooking() {
        navigate({
            search: createSearchParams(bookingLogin).toString()
        });

    }

    if(booking != null) {
        return (
            <div className="wrapper" style={{padding: '0px 10px 0px 10px'}}>
                <div className="grid">
                    <div className="col-12 md:col-8">
                        <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '1rem 1rem 0rem 0rem'}}>
                            <span className="pl-2 text-2xl font-semibold">Teilnehmer:</span>
                            <div style={{padding: '5px 0 0 20px'}}>
                                {booking.participants.map(participant => (
                                    <div>
                                        <i className="pi pi-user" style={{ color: '#01d997', fontSize: '0.9rem' }}></i> <b>{participant.firstName}, {participant.lastName}</b> ({participant.dateOfBirth})
                                    </div>
                                ))}
                            </div>
                        </PanelForm>
                        <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem'}}>
                            <span className="pl-2 text-2xl font-semibold">Ereignisse:</span>
                            <div style={{padding: '5px 0 0 20px'}}>
                                {booking.events.map(event => (
                                    <div>
                                        <div style={{padding:'0px 4px'}}>
                                            <i className="pi pi-stopwatch" style={{ color: '#01d997', fontSize: '0.9rem' }}></i>
                                            <span style={{fontWeight: 'bold'}}> {event.timeDisplay}</span>
                                        </div>
                                        <div style={{padding:'5px 0px 10px 25px'}}>{event.typeDisplay}</div>
                                    </div>
                                ))}
                            </div>
                        </PanelForm>

                        {(booking.lastEvent?.type === 'APPOINTMENT_RESERVED' || booking.lastEvent?.type === 'APPOINTMENT_RESERVED_EXPIRE_SOON' || booking.lastEvent?.type === 'BOOKED') && (
                            <React.Fragment>

                                <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem'}}>
                                    <span className="pl-2 text-2xl font-semibold">Anerkennungen:</span>
                                    <div style={{padding: '5px 0 0 20px'}}>

                                        {booking.extension?.trip?.extension?.recognizedStates?.map( recognizedState => (
                                            <div>
                                                <div style={{cursor: 'pointer'}} onClick={() => setExpandedRecognizedState(recognizedState.code)}>
                                                    > {recognizedState.label}
                                                </div>
                                                <div style={{paddingLeft: '15px'}}>
                                                    {booking.extension?.trip?.extension?.recognitions?.map( attachment => {
                                                            if(attachment.groupName === recognizedState.code && expandedRecognizedState === recognizedState.code ) {
                                                                recognizedState.show = true;
                                                                return (
                                                                    <div>
                                                                        <i className="pi pi-file-pdf" style={{ color: '#01d997', fontSize: '0.9rem', paddingRight: 2 }}></i>
                                                                        <a style={{textDecoration: 'none', color: '#004858'}} href={"/api/attachments/" + attachment.id} target="_blank">{attachment.filename}</a>
                                                                    </div>
                                                                )
                                                            }

                                                        }

                                                    )}
                                                </div>

                                            </div>
                                        ))}

                                    </div>
                                </PanelForm>

                                <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem'}}>
                                    <span className="pl-2 text-2xl font-semibold">Ihre Dokumente:</span>
                                    <div style={{padding: '5px 0 0 20px'}}>
                                        <table style={{ borderSpacing: 0}} cellSpacing="0" cellPadding="0">
                                            <tbody>
                                            {booking.extension?.trip?.extension?.attachments?.map( attachment =>
                                                <tr className={styles.tableRow}>
                                                    <td>
                                                        <i className="pi pi-file-pdf" style={{ color: '#01d997', fontSize: '0.9rem' }}></i>
                                                    </td>
                                                    <td style={{padding: '2px 15px 2px 5px'}}>
                                                        <a style={{textDecoration: 'none', color: '#004858'}} href={"/api/attachments/" + attachment.id} target="_blank">{attachment.filename}</a>
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>

                                    </div>
                                </PanelForm>

                                {(booking.lastEvent?.type === 'APPOINTMENT_RESERVED' || booking.lastEvent?.type === 'APPOINTMENT_RESERVED_EXPIRE_SOON') && (
                                    <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem'}}>
                                        <span className="pl-2 text-2xl font-semibold">Ansprechpartner:</span>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <th style={{textAlign: 'left', verticalAlign: 'top', paddingRight: 10}}></th>
                                                <td>
                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="email">Vorname:</label>
                                                        <InputText
                                                            id="accountFirstname"
                                                            value={confirmRequest.firstName}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, firstName: e.target.value})}/>
                                                    </div>

                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="email">Nachname:</label>
                                                        <InputText
                                                            id="accountLastname"
                                                            value={confirmRequest.lastName}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, lastName: e.target.value})}/>
                                                    </div>

                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="accountStreet">Strasse:</label>
                                                        <InputText
                                                            id="accountFirstname"
                                                            value={confirmRequest.street}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, street: e.target.value})}/>
                                                    </div>

                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="email">Hausnummer:</label>
                                                        <InputText
                                                            id="accountHouseNumber"
                                                            value={confirmRequest.houseNumber}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, houseNumber: e.target.value})}/>
                                                    </div>

                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="email">Stadt:</label>
                                                        <InputText
                                                            id="accountCity"
                                                            value={confirmRequest.city}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, city: e.target.value})}/>
                                                    </div>

                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="email">Bundesland:</label>
                                                        <InputText
                                                            id="accountState"
                                                            value={confirmRequest.state}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, state: e.target.value})}/>
                                                    </div>

                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="email">Land:</label>
                                                        <InputText
                                                            id="accountCountry"
                                                            value={confirmRequest.country}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, country: e.target.value})}/>
                                                    </div>

                                                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                                                        <label htmlFor="email">Handynummer:</label>
                                                        <InputText
                                                            id="accountMobilePhone"
                                                            value={confirmRequest.mobilePhone}
                                                            onChange={(e) => setConfirmRequest({... confirmRequest, mobilePhone: e.target.value})}/>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td><br/></td>
                                            </tr>
                                            <tr>
                                                <th style={{textAlign: 'right', verticalAlign: 'top' , paddingRight: 5}}>
                                                    <Checkbox onChange={e => setCheckAgbAccepted(e.checked)} checked={checkAgbAccepted}></Checkbox>
                                                </th>
                                                <td>
                                                    <div style={ !checkAgbAccepted && highlightCheckboxes ? {color: 'red'} : null}>„Ich habe die AGB und Stornobedingungen des Veranstalters gelesen und akzeptiere sie.“</div>
                                                    <div style={{padding: '5px 0 0 20px'}}>
                                                        AGB + Stornobedingungen des Veranstalters:<br/>

                                                        <ul>
                                                            <li><a href={booking.organizerAgbUrl} target="_blank">{booking.organizerAgbUrl}</a></li>
                                                            {booking.extension?.trip?.extension?.organizerAgbs?.map( attachment => (
                                                                <li>
                                                                    <a href={"/api/attachments/" + attachment.id} target="_blank">{attachment.filename}</a>
                                                                </li>
                                                            ))}
                                                        </ul>


                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td><br/></td>
                                            </tr>
                                            <tr>
                                                <th style={{textAlign: 'right', paddingRight: 5}}>
                                                    <Checkbox onChange={e => setCheckBildungsurlaubAccepted(e.checked)} checked={checkBildungsurlaubAccepted}></Checkbox>
                                                </th>
                                                <td style={ !checkBildungsurlaubAccepted && highlightCheckboxes ? {color: 'red'} : null}>
                                                    „Ich ermächtige bildungs-urlaub.com, in meinem Namen eine verbindliche Buchung bei [Veranstalter] vorzunehmen und meine Daten für diesen Zweck weiterzugeben.“
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td><br/></td>
                                            </tr>
                                            <tr>
                                                <th style={{textAlign: 'right', paddingRight: 5}}>

                                                </th>
                                                <td>
                                                    {checkAgbAccepted && checkBildungsurlaubAccepted && (
                                                        <Button label="jetzt verbindlich Buchen" onClick={() => postBookingConfirm()}></Button>
                                                    )}
                                                    {(!checkAgbAccepted || !checkBildungsurlaubAccepted) && (
                                                        <Button style={{backgroundColor: '#a5b396'}} label="jetzt verbindlich Buchen" onClick={() => setHighlightCheckboxes(true)}></Button>
                                                    )}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </PanelForm>
                                )}
                                <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem 0rem 1rem 1rem'}}>
                                    <span className="pl-2 text-2xl font-semibold">Veranstalter:</span>
                                    <div style={{padding: '5px 0 0 20px'}}>
                                        Hinweis: „Vertragspartner ist [{booking.organizer}]“
                                    </div>
                                </PanelForm>
                            </React.Fragment>
                        )}


                    </div>

                    <div className="col-12 md:col-4">

                        <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '1rem'}}>

                            <div className="pl-2 text-2xl font-semibold">Ihre Anfrage:</div>
                            <div className="flex flex-wrap" style={{justifyContent: 'center'}}>
                                <div>
                                    <ListItem
                                        trip={
                                            {
                                                ...booking.extension.trip,
                                                name: booking.name,
                                                location: booking.location,
                                                price: booking.price,
                                                currency: booking.currency,
                                                appointmentDate: booking.appointmentDate,
                                                appointmentLength: booking.appointmentLength
                                            }
                                        }
                                    />
                                </div>


                                <table style={{padding: '20px'}}>
                                    <tbody>
                                    <tr>
                                        <th style={{textAlign: 'left', width: '120px'}}>Email:</th>
                                        <td>{booking.email}</td>
                                    </tr>
                                    <tr>
                                        <th style={{textAlign: 'left', width: '120px'}}>Code:</th>
                                        <td>{booking.code}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><br/></td>
                                    </tr>
                                    <tr>
                                        <th style={{textAlign: 'left'}}>Gesamtpreis:</th>
                                        <td>{booking.priceSum}  {booking.currency}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </PanelForm>

                    </div>
                </div>





            </div>
        )
    } else {
        return (
            <div className="wrapper"  style={{padding: '0 10px 0 10px', maxWidth: "640px"}}>
                <PanelForm style={{background: '#FFFFFF', padding: 15, marginTop: 'calc(50vh - 400px)'}}>

                    <h1>Buchung aufrufen</h1>
                    <div style={{fontSize: '16px', padding: '10px 0px'}}>
                        Geben Sie Ihre E-Mail-Adresse und Ihren Buchungscode ein, um Ihre Buchung aufzurufen.
                    </div>
                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                        <label htmlFor="email">E-Mail-Adresse:</label>
                        <InputText
                            id="accountFirstname"
                            value={bookingLogin.email}
                            onChange={(e) => setBookingLogin({... bookingLogin, email: e.target.value})}/>
                    </div>
                    <div className="flex flex-column" style={{paddingBottom: 5}}>
                        <label htmlFor="email">Buchungscode:</label>
                        <InputText
                            id="accountFirstname"
                            value={bookingLogin.code}
                            onChange={(e) => setBookingLogin({... bookingLogin, code: e.target.value})}/>
                    </div>
                    <Button label="Buchung öffnen" onClick={() => openBooking(bookingLogin)}/>
                    {bookingLoginInvalid && (
                        <div style={{color: 'red', padding: '5px 10px 5px 10px'}}>
                            Bei falscher Kombination aus E-Mail und Buchungscode: Die eingegebenen Daten konnten nicht gefunden werden. Bitte prüfen Sie Ihre E-Mail-Adresse und den Buchungscode.<br/>

                        </div>
                    )}
                </PanelForm>
            </div>
        )
    }
}